import { motion } from "framer-motion";
import { ReactComponent as CreativeIcon } from "../assets/images/creativeIcon.svg";
import { ReactComponent as EuphoricIcon } from "../assets/images/euphoricIcon.svg";
import { ReactComponent as FocusedIcon } from "../assets/images/focusedIcon.svg";
import { ReactComponent as GiggleIcon } from "../assets/images/giggleIcon.svg";
import { ReactComponent as HappyIcon } from "../assets/images/happyIcon.svg";
import { ReactComponent as HungryIcon } from "../assets/images/hungryIcon.svg";
import { ReactComponent as RelaxIcon } from "../assets/images/relaxIcon.svg";
import { ReactComponent as SleepyIcon } from "../assets/images/sleepyIcon.svg";
import { ReactComponent as UpliftedIcon } from "../assets/images/upliftedIcon.svg";
import { ReactComponent as TinglyIcon } from "../assets/images/tinglyIcon.svg";
import { ReactComponent as ChatIcon } from "../assets/images/chatIcon.svg";

const iconMap = {
  creative: CreativeIcon,
  euphoric: EuphoricIcon,
  focused: FocusedIcon,
  giggly: GiggleIcon,
  happy: HappyIcon,
  hungry: HungryIcon,
  relaxed: RelaxIcon,
  sleepy: SleepyIcon,
  uplifted: UpliftedIcon,
  tingly: TinglyIcon,
  talkative: ChatIcon,
};

export default function Fillings({ fillings }) {
  return (
    <div className="fillings-container">
      {fillings.map((filling, index) => {
        const key = filling.toLowerCase();
        const Icon = iconMap[key];
        return (
          <motion.div
            key={filling}
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: index * 0.2 }}
            viewport={{ once: true }}
            className="filling-item"
          >
            {Icon && <Icon className="filling-icon" />}
            <span>{filling}</span>
          </motion.div>
        );
      })}
    </div>
  );
}
